/* eslint-disable */
class FinanceUtil { // This is a copy of the FinanceUtil from the borrower flow, let it be known!
  constructor(amount, product, loan) {
    this.product = product;
    this.loan = loan;
    this.amount = parseInt(amount, 10);
  }

  getRateHashValue(hash, value) {
    return !!hash
      ? Number(hash[value].substring(0, hash[value].length - 1))
      : undefined;
  }

  get defaultPrimeRate() {
    // this need to be updated everytime the rate is changed, its mostly for the apply page
    return this.isConventional ? 0 : 5.5
  }

  get finalTerm() {
    return this.product.term || this.loan.term;
  }

  get yearTerm() {
    return parseInt(this.finalTerm, 10);
  }

  get loanTermYears() {
    return parseInt(this.finalTerm / 12, 10);
  }

  get isCre() {
    return this.product.category === 'cre' || this.finalTerm === 300;
  }

  get isConventional() {
    return this.product.productType === 'conventional' || this.finalTerm <= 60;
  }

  get finalRateHash() {
    const hashRate =
      this.product.rateHash || (!!this.loan ? this.loan.rateHash : undefined);
    return !!hashRate ? JSON.parse(hashRate) : undefined;
  }

  finalValue(firstVal, secondVal) {
    let finalValue;
    if (this.isConventional) {
      finalValue = this.product && this.product[firstVal];
    } else if (!!this.loan && this.loan.state !== 'advisor') {
      finalValue = this.loan[secondVal];
    }
    return finalValue;
  }

  get finalPrime() {
    const finalPrime = this.finalValue('prime', 'primeRate');
    return finalPrime || finalPrime === 0 ? finalPrime : this.defaultPrimeRate;
  }

  get finalSpread() {
    if (this.isConventional) {
      const finalSpread = this.finalValue('spread', 'spread');
      return finalSpread;
    }
    return this.tier.spread;
  }

  get tier() {
    const loanInfo = JSON.parse(this.product.tierRates || this.loan.loanInfo);

    return loanInfo.find(i => this.amount <= i.max_loan_amount);
  }

  get calcTotalFees() {
    return (
      this.fixedFees +
      this.packagingFees +
      this.referralFees +
      this.guarantyFees
    );
  }

  get monthlyPayment() {
    return (
      (this.amount * (this.interestRate / 100 / 12)) /
      (1 - Math.pow(1 + this.interestRate / 100 / 12, -1 * this.yearTerm))
    );
  }

  get interestRate() {
    return this.finalSpread + this.finalPrime;
  }

  get apr() {
    let amount = this.amount - this.calcTotalFees,
      rate = this.interestRate / 100 / 12,
      testrate = rate,
      iteration = 1,
      testresult = 0,
      testdiff = testrate;
    while (iteration <= 100) {
      testresult =
        (testrate * Math.pow(1 + testrate, this.yearTerm)) /
        (Math.pow(1 + testrate, this.yearTerm) - 1) -
        this.monthlyPayment / amount;
      if (Math.abs(testresult) < 0.0000001) break;
      if (testresult < 0) testrate += testdiff;
      else testrate -= testdiff;
      testdiff = testdiff / 2;
      iteration++;
    }
    return testrate * 12 * 100;
  }

  get fixedFees() {
    return this.product.fixedFees || this.tier.fees.fixed;
  }

  get packagingFees() {
    return (
      (this.product.packagingFeePercent || this.tier.fees.packaging) *
      this.amount
    );
  }

  get referralFees() {
    return (
      (this.product.referralFeePercent || this.tier.fees.referral) * this.amount
    );
  }

  get guarantyFees() {
    const { guarantyFees } = this.product;
    if (!!guarantyFees) {
      return guarantyFees;
    } else {
      if (this.isConventional) return 0;
      let fees = this.tier.fees,
        step = fees.guaranty_step || this.amount,
        lower = Math.min(step, this.amount) * fees.guaranty_1,
        upper = Math.max(this.amount - step, 0) * (fees.guaranty_2 || 0);
      return lower + upper;
    }
  }

  get spreadLow() {
    let defaultSpread = 2.75;
    if (this.isCre) {
      defaultSpread = 1.5;
    }
    if (this.isConventional) {
      defaultSpread = 6.99;
    }
    return (
      this.getRateHashValue(this.finalRateHash, 'spread_low') || defaultSpread
    );
  }

  get spreadHigh() {
    let defaultSpreadH = 3.75;
    if (this.isCre) {
      defaultSpreadH = 2.75;
    }
    if (this.isConventional) {
      defaultSpreadH = 26.99;
    }
    return (
      this.getRateHashValue(this.finalRateHash, 'spread_high') || defaultSpreadH
    );
  }

  get spreadRange() {
    return `${this.spreadLow.toFixed(2)}% to ${this.spreadHigh.toFixed(2)}%`;
  }
}

export default FinanceUtil;
